import type { SVGProps } from "react";
export interface ToothBrokenIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ToothBrokenIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ToothBrokenIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 8.5c0-1.548-.444-2.912-1.196-3.865-.732-.927-1.786-1.51-3.178-1.51-.69 0-1.597.368-2.442.851l-.036.02 1.601 1.068.093.07a1.126 1.126 0 0 1-1.242 1.861l-.098-.058-3-2.001-.08-.058-.006-.004-.03-.025a12 12 0 0 0-1.623-1.037L9.15 5.127c-.17.463-.541.82-1.002.976l-.202.054-1.49.3-.287 1.426a1.63 1.63 0 0 1-1.082 1.223l-.243.06-1.638.272c.063.433.16.94.293 1.506.24 1.03.576 2.196.948 3.375a114 114 0 0 0 2.141 6.091l.047.1c.127.22.367.364.643.364.3 0 .573-.175.696-.45l1.236-2.746a3.059 3.059 0 0 1 5.579 0l1.234 2.747c.124.274.397.45.698.45a.73.73 0 0 0 .69-.465l.45-1.198a107 107 0 0 0 1.691-4.893c.372-1.179.706-2.344.947-3.375.244-1.049.375-1.889.375-2.444Zm2.25 0c0 .823-.18 1.868-.434 2.956a50 50 0 0 1-.992 3.54c-.762 2.42-1.656 4.83-2.185 6.217a2.98 2.98 0 0 1-2.792 1.912 3.01 3.01 0 0 1-2.748-1.777L12.737 18.6a.809.809 0 0 0-1.418-.102l-.055.102-1.237 2.747a3.01 3.01 0 0 1-2.748 1.777 2.98 2.98 0 0 1-2.7-1.698l-.092-.214a116 116 0 0 1-2.185-6.217 50 50 0 0 1-.993-3.54C1.055 10.368.875 9.323.875 8.5c0-.55.398-1.019.94-1.11l2.233-.373.284-1.41.064-.235a1.63 1.63 0 0 1 1.21-1.04l1.556-.313.61-1.65.065-.15c.332-.676 1.121-1.077 1.9-.837l.167.061.563.263c.544.273 1.029.57 1.4.817q.069.047.132.092c.26-.176.58-.384.943-.592C13.847 1.506 15.19.875 16.5.875c2.107 0 3.803.918 4.946 2.366 1.123 1.422 1.678 3.307 1.678 5.259Z"
      />
    </svg>
  );
}
